if (!customElements.get('html-preview')) {
    customElements.define('html-preview', class extends HTMLElement {
        connectedCallback() {
            const shadow = this.attachShadow({ mode: 'open' });
            shadow.innerHTML = this.dataset.html || '';
        }
    });
}
